import React, { useState } from 'react';
import { bonusPointsContainerStyle as styles } from './claimBonusPoints.tailwind';
import Button from '../../../../shared/Button/Button';
import { connect, useSelector } from 'react-redux';
import { claimBonusPoint } from '../../../../../redux/slices/earnPointSlice';
import { BONUS_CLAIM_TYPE, getActivityTypeImage } from '../../../../../lib/constants/globalConstant';
import ConfirmBonusClaimModal from '../../../../shared/Modals/ConfirmBonusClaimModal/ConfirmBonusClaimModal';

const BonusPointsContainer = ({ bonusPoint, claimPoint }) => {
  const { currentSeason } = useSelector(state => state.seasons);

  const [isClaiming, setIsClaiming] = useState(false);  // Local state to manage claiming process
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleEachClaim = () => {
    if (!bonusPoint?.isClaimed) {
      setIsClaiming(true);  // Set claiming state to true
      claimPoint({ bonusDetailId: bonusPoint?._id, claimType: BONUS_CLAIM_TYPE.SINGLE, seasonId: currentSeason?._id })
        .finally(() => {
          setIsModalOpen(false); 
          setIsClaiming(false)
        });  // Set claiming state to false after the process completes
    }
  };

  // Conditionally set the background color based on whether the bonus is claimed or not
  const buttonClass = bonusPoint?.isClaimed
    ? `text-gray-600 bg-white bg-gradient-to-t from-black/30 to-black/30 pointer-events-none  ${styles.button}`  // If claimed, use green background
    : `${styles.button}`;  // Otherwise, keep default button styling

  return (
    <div className={styles.outerContainer}>
      <div className={styles.bonusPoint}>
        <figure className={styles.image}>
          <img src={getActivityTypeImage(bonusPoint?.activityTypeId)} alt="bonus_point" />
        </figure>
        <div className={styles.bonusDetails}>
          <span className={styles.heading}>{bonusPoint?.activityTitle}</span>
          <span className={styles.subHeading}>
            You&apos;ve successfully earned {bonusPoint?.bonuspoints} bonus points!
          </span>
        </div>
      </div>
      <Button
        variant="secondary"
        className={`${buttonClass}`}
        onClick={() => setIsModalOpen(true)}
        disabled={isClaiming}
      >
        {isClaiming ? 'Claiming...' : bonusPoint?.isClaimed ? 'Claimed' : 'Claim Now'}
      </Button>
      {/* Pass bonus data and claim function to the modal */}
      {isModalOpen && (
        <ConfirmBonusClaimModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          onClaim={handleEachClaim} // Pass function
          bonusDetail={{
            bonusTitle: bonusPoint?.activityTitle,
            pointsValue: bonusPoint?.bonuspoints,
          }}
        />
      )}
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  claimPoint: (data) => dispatch(claimBonusPoint(data)),
});

export default connect(null, mapDispatchToProps)(BonusPointsContainer);
